<template>
  <editor
    v-model="editorValue"
    tinymce-script-src="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.0.0/tinymce.min.js"
    :init="init"></editor>
</template>

<script setup>
import { reactive, ref, watch, toRefs } from 'vue'

import Editor from '@tinymce/tinymce-vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  plugins: {
    type: [String, Array],
    default: 'quickbars emoticons table',
  },
  toolbar: {
    type: [String, Array],
    default:
      ' bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify|bullist numlist |outdent indent blockquote | undo redo | axupimgs | removeformat | table | emoticons',
  },
    initOptions: {
      type: Object,
        default: () => ({})
    }
})

const emit = defineEmits(['update:modelValue'])

const init = reactive(Object.assign({
  height: '100%',
  menubar: false,
  plugins: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount',
  ],
  toolbar:
    'undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help',
}, props.initOptions))

const { modelValue } = toRefs(props)
const editorValue = ref(modelValue.value)

watch(modelValue, newValue => {
  editorValue.value = newValue
})

watch(editorValue, newValue => {
  emit('update:modelValue', newValue)
})
</script>
